import { useCallback, useMemo, useState } from "react"

/**
 * Custom hook for managing common Health subpage state and logic
 * Handles pagination, sorting, and table settings
 */
export const useHealthSubpage = (pageSize = 50) => {
  const [pageNumber, setPageNumber] = useState(1)
  const [ordering, setOrdering] = useState(null)

  const handleChangeTable = useCallback((pagination, filters, sorter) => {
    let ordering = null
    if (sorter) {
      if (Array.isArray(sorter)) {
        ordering = sorter
          ?.map(({ field, order }) => (order === "ascend" ? field : `-${field}`))
          .join(",")
      } else {
        if (sorter.order) {
          ordering = sorter.order === "ascend" ? sorter.field : `-${sorter.field}`
        }
      }
    }
    setPageNumber(pagination.current)
    setOrdering(ordering)
  }, [])

  const resetPagination = useCallback(() => {
    setPageNumber(1)
    setOrdering(null)
  }, [])

  return {
    pageNumber,
    ordering,
    handleChangeTable,
    resetPagination,
    setPageNumber,
    setOrdering
  }
}

/**
 * Hook for creating table settings with pagination
 */
export const useTableSettings = (count, pageNumber, pageSize, customScroll) => {
  return useMemo(
    () => ({
      scroll: customScroll || (count > 0 ? { x: "auto" } : {}),
      pagination: {
        total: count,
        current: pageNumber,
        pageSize: pageSize,
        showSizeChanger: false
      }
    }),
    [count, pageNumber, pageSize, customScroll]
  )
}
